// extracted by mini-css-extract-plugin
module.exports = {"container":"BoxIcon_container__zwYjc","icon":"BoxIcon_icon__8JNAv","iconSmall":"BoxIcon_iconSmall__k9rEh","name":"BoxIcon_name__miDmf"};